module.exports = __webpack_public_path__ + "static/media/AddParticipantIcon.66684bc4.svg";